import { useEffect } from 'react';

/**
 * While `active` is true, warn the user before they refresh or close the tab —
 * used to protect an in-flight tileset upload. Modern browsers show their own
 * generic prompt and ignore custom text, so we only signal that there is unsaved
 * work; we do not attempt a custom message.
 */
export function useUnloadGuard(active: boolean): void {
	useEffect(() => {
		if (!active) return;
		const handler = (event: BeforeUnloadEvent) => {
			event.preventDefault();
			event.returnValue = '';
		};
		window.addEventListener('beforeunload', handler);
		return () => window.removeEventListener('beforeunload', handler);
	}, [active]);
}
